var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7135_92028)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.19014 4.42668C4.53814 5.15149 5.01253 5.83081 5.61332 6.4316C6.21411 7.03238 6.89343 7.50678 7.61824 7.85478C7.68059 7.88471 7.71176 7.89968 7.7512 7.91118C7.89138 7.95204 8.06351 7.92269 8.18222 7.83768C8.21563 7.81376 8.24421 7.78518 8.30136 7.72803C8.47617 7.55322 8.56357 7.46582 8.65146 7.40868C8.9829 7.19318 9.41019 7.19318 9.74164 7.40868C9.82953 7.46582 9.91693 7.55322 10.0917 7.72803L10.1892 7.82546C10.4549 8.09118 10.5877 8.22404 10.6599 8.36673C10.8035 8.65051 10.8035 8.98565 10.6599 9.26943C10.5877 9.41212 10.4549 9.54498 10.1892 9.8107L10.1103 9.88952C9.84554 10.1543 9.71313 10.2867 9.53312 10.3879C9.33336 10.5001 9.02312 10.5808 8.79401 10.5801C8.58753 10.5795 8.44642 10.5394 8.1642 10.4593C6.6475 10.0288 5.21632 9.21658 4.02233 8.02259C2.82834 6.8286 2.0161 5.39742 1.58562 3.88072C1.50551 3.59849 1.46546 3.45738 1.46485 3.25091C1.46417 3.0218 1.54485 2.71155 1.65706 2.5118C1.75818 2.33178 1.89059 2.19938 2.1554 1.93457L2.23422 1.85575C2.49994 1.59003 2.6328 1.45717 2.77549 1.385C3.05927 1.24146 3.3944 1.24146 3.67818 1.38499C3.82087 1.45717 3.95373 1.59003 4.21945 1.85575L4.31689 1.95318C4.49169 2.12799 4.57909 2.21539 4.63624 2.30328C4.85173 2.63472 4.85173 3.06201 4.63624 3.39346C4.57909 3.48135 4.49169 3.56875 4.31689 3.74355C4.25973 3.80071 4.23115 3.82929 4.20723 3.86269C4.12223 3.98141 4.09288 4.15354 4.13374 4.29371C4.14524 4.33316 4.1602 4.36433 4.19014 4.42668Z",
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7135_92028"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.8d972acc066a01e1f9be1640069d98db.svg";
export { ForwardRef as ReactComponent };